function addPost(sess, post, discussionId) { 
    const {Discussion, ForumUser, Post, Reply} = sess;
    const userModel = ForumUser.create({
        id: post.user.id,
        fullName: post.user.fullName,
        image: post.user.image,
        role: post.user.role
    });
    const postModel = Post.create({
        id: post.id,
        user: userModel,
        content: post.content,
        sendDate: post.sendDate,
        isLiked: post.isLiked,
        likes: post.likes,
        reply: post.reply && Reply.create({
            content: post.reply.content,
            postId: post.reply.postId,
            userName: post.reply.userName,
            userRole: post.reply.userRole,
        }),
        mentionedStudents: post.mentionedStudents
    });
    if (!Discussion.withId(discussionId).posts || !Discussion.withId(discussionId).posts.filter({id: postModel.id}).exists()) {
        Discussion.withId(discussionId).posts.add(postModel);
    }
}

function removePost(sess, id) {
    const { Post } = sess;
    const targetPost = Post.withId(id);
    targetPost.attachments.all().delete();
    targetPost.delete();

}

function updateRepliesList(sess, {repliesId, totalPage, page, nextPage, prePage, filters}) {
    const { List } = sess;
    let discussionsListModel = List.getByName('replies');
    if (!discussionsListModel) {
        List.create({
            name: 'replies',
            entityIds: repliesId,
            filters: Object.entries(filters),
            page,
            totalPage,
            nextPage,
            prePage
        })
    } else {
        discussionsListModel.update({
            entityIds: repliesId,
            filters: Object.entries(filters),
            page,
            totalPage,
            nextPage,
            prePage
        });
    }
}

function likePost(sess, id, isLiked) {
    const {Post} = sess;;
    if (!Post.exists({id})) {
        throw new Error(`there is not any forum post with this id '${id}'`);
    }
    const targetPost = Post.withId(id);
    targetPost.update({
        isLiked: isLiked,
        likes: isLiked ? targetPost.likes + 1 : targetPost.likes - 1,
    })
    return targetPost;
}

export default {
    addPost,
    removePost,
    updateRepliesList,
    likePost,
}